import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--ink-1)" }}>
        <div className="text-sm text-white/50" data-testid="auth-loading">Checking session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && user.role !== role) {
    // Solo players use the same player surface
    if (role === "player" && user.role === "solo_player") return children;
    const home = user.role === "admin" ? "/admin" : user.role === "coach" ? "/dashboard" : (user.role === "solo_player" ? "/portal" : "/portal");
    return <Navigate to={home} replace />;
  }
  return children;
}
